import { createApp } from 'vue';
import CookieConsent from './components/CookieConsent.vue';

const el = document.getElementById('cookie-consent-root');
if (el) {
  createApp(CookieConsent).mount(el);
} 